import NetworkState from '../../../core/types/network';
import { ReduxAction, DispatchFunc } from '../../../core/types/redux';
import { Person } from '../person/types';

export type LoginMode = 'place' | 'person';

export enum LoginActionConstants {
  INITIALIZE = '@@login/INITIALIZE',
  LOGIN_REQUEST = '@@login/LOGIN_REQUEST',
  LOGIN_SET = '@@login/LOGIN_SET',
  LOGIN_SESSION_REQUEST = '@@login/LOGIN_SESSION_REQUEST',
  LOGIN_SESSION_SET = '@@login/LOGIN_SESSION_SET',
}

export interface RequestLoginArgs {
  username: string;
  password: string;
  remember: boolean;
}

export interface LoginInfo {
  status: string;
  data?: {
    mode?: LoginMode;
    apiToken?: string;
    userId?: string;
    userPlaceId?: string;
    username?: string;
    userPersonName?: Person;
    userType?: string;
    userPosition?: string;
  };
  message?: string;
}

export interface SetLoginSessionArgs {
  result?: LoginInfo;
  error?: Error;
}

export interface SetLoginArgs {
  result?: LoginInfo;
  error?: Error;
}

export type LoginAction<TArgs> = ReduxAction<TArgs, LoginActionConstants>;
export type LoginDispatchFunc<TArgs> = DispatchFunc<TArgs, LoginActionConstants>;

export interface LoginState {
  loginNetworkStates: {
    loginSessionRequest: NetworkState;
    loginRequest: NetworkState;
  };
  isInitialized: boolean;
  loginStatus?: LoginInfo;
}
